/**
 * 进程管理
 */
const InvestigateRouter = {
  path: '/investigat',
  component: () => import('@/views/layout'),
  redirect: '/administration/purchase/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [{
    path: '/administration/purchase/approval_infos/:id/:type',
    name: 'approvalInfo',
    component: () => import('@/views/administration_manage/purchase_manage/approve/approval_infos'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/purchase/count_detail/:id',
    name: 'countDetail',
    component: () => import('@/views/administration_manage/purchase_manage/approve/count_detail'),
    hidden: true,
    meta: {
      title: '详情'// 采购统计详情
    }
  }

  ]
}

export default InvestigateRouter
